Backbone = require 'backbone'
V2OptimizedContactChannelsTemplate = require('../../v2_optimized_contact_channels.html.mustache')

class SupportV2OptimizedContactChannelsModel extends Backbone.Model

  initialize: ->
    @template = V2OptimizedContactChannelsTemplate

  toHash: ()->
    @setOrderInfo()
    @setIssueInfo()
    @toJSON()

  setOrderInfo: ->
    order = Groupon.Support.currentOrder
    if order
      title = order.deal?.title || order.merchant?.name
      if title
        @set('orderMsg', I18n.translate('js.modules.support.issue_about_this_order', {dealTitle: title}))

  setIssueInfo: ->
    issue = Groupon.Support.ContentModel.getSearchInputIssue() || Groupon.Support.ContentModel.getSubCategory()?.text
    if issue
      @set('issueMsg', I18n.translate('js.modules.support.saw_you_have_issue', {issue: issue}))

  hidePreferencedContactChannel: ->
    optimizedContactChannels = [@optimizephoneBtnElem(), @optimizeEmailBtnElem(), @optimizedLiveChatContainer()]
    removePreferredContactClass optimizedContactChannels

  showPreferencedContactChannel: (type) ->
    switch type
      when "chat"
        preferredContactElem = @optimizedLiveChatContainer()
      when "email"
        preferredContactElem = @optimizeEmailBtnElem()
      when "phone"
        preferredContactElem = @optimizephoneBtnElem()
    addPreferredContactClass preferredContactElem

  optimizedLiveChatVisible: ->
    window.liveChatVisible $(".live-chat-container.optimized-contact-channel a img")

  setOptimizedLiveChatDisplayCallBack: (liveChatDisplayCallback)->
    window.setLiveChatDisplayCallBack $(".live-chat-container.optimized-contact-channel a img"), liveChatDisplayCallback

  optimizephoneBtnElem: ->
    $('.optimized-phone-btn')

  optimizeEmailBtnElem: ->
    $('.optimized-email-us')

  optimizedLiveChatContainer: ->
    $('.optimized-live-chat-container')

  emailRecommendationTextElement : ->
    $('')

  phoneRecommendationTextElement : ->
    $('')

module.exports = SupportV2OptimizedContactChannelsModel
